import { useWorkspaceFeatureFlags } from "src/contexts/global/WorkspaceContext";

/**
 * Workspace-level Team Canvas visibility flag.
 *
 * Reads the existing `enableDemoODOptions` workspace feature flag, which is
 * the backend-supported key set via the Internal Dashboard.
 */
export const useTeamCanvasEnabled = (): { enableODDemoOptions: boolean } => {
  const { enableDemoODOptions } = useWorkspaceFeatureFlags();
  return { enableODDemoOptions: enableDemoODOptions ?? false };
};
